export class Currency {
  code: string
  img: string
  icon: string
  symbol: string
}
